import { getVideo, hasVideo } from "../../component";
import CardFeatured from "../CardFeatured/component";

/**
 * Component to provide inline video player to card components
 *
 */
export const GetVideoPlayerForCard = (props) => {
    //To make Item component naming compatible with getVideo function
    const cardIndex =
        props.contentIndex !== undefined ? props.contentIndex : props.cardIndex;
    const type = props.type !== undefined ? props.type : props.itemType;

    const CardComponent = props.component;

    const newProps = { ...props, cardIndex, type };

    // To get the Video displayed by the card (if any)
    const media = hasVideo(newProps) && getVideo(newProps);

    // eslint-disable-next-line no-unused-vars
    const { component, ...restProps } = newProps;

    const childProps = { ...restProps, media };

    return <CardComponent {...childProps} />;
};

//These are used in Flexible Landing Page (a.k.a. LandingMultiFeed) to render these cards without using the Card component.
export const CardFeaturedVideoEnabled = (props) => (
    <GetVideoPlayerForCard {...props} component={CardFeatured} />
);

export const CardFeaturedAuthorVideoEnabled = (props) => (
    <GetVideoPlayerForCard
        {...props}
        displayAuthor={true}
        component={CardFeatured}
    />
);

export default GetVideoPlayerForCard;
